import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { rescheduleReasons } from "./common/constants";
import { availableDoctors, getProvidersCalendar, updateRequests } from "./common/apiCalls";
import { toast } from "react-toast";
import moment from "moment";

export default function RescheduleDialog({
  appointmentDate,
  requestId,
  speciality,
  patientName,
  doctorName,
  rescheduleDialogVisible,
  setRescheduleDialogVisibility,
  fetchData,
  setFetchData,
  doctorId,
  packageId,
  currentProvider,
  contractId,
}) {
  const [doctor, setDoctor] = useState(doctorName);
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [rescheduleDate, setRescheduleDate] = useState(moment(appointmentDate).format("YYYY-MM-DD"));
  const [rescheduleTime, setRescheduleTime] = useState(moment(appointmentDate).format("HH:mm"));
  const [doctorList, setDoctorList] = useState([]);
  const [showSlots, setShowSlots] = useState(false);
  const [dateSlots, setDateSlots] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [orderDateTime, setOrderDateTime] = useState(null);
  const [slotDistributionForDate, setSlotDistributionForDate] = useState(null);
  const [slotDistributionForInterval, setSlotDistributionForInterval] = useState(null);
  const [doctorIdSelected, setDoctorId] = useState(doctorId);
  const [loading, setLoading] = useState(true);

  const updateRequest = async () => {
    try {
      let action = doctorIdSelected != doctorId ? "CHANGE_DOCTOR" : "Reschedule";
      let scheduledAppointmentDate = orderDateTime ? orderDateTime : new Date(rescheduleDate + " " + rescheduleTime);
      let updateRequestRemark = "";
      if (reason === "Others") {
        updateRequestRemark = "Others - " + otherReason;
      } else {
        updateRequestRemark = reason;
      }
      setRescheduleDialogVisibility(false);
      let response = await updateRequests(
        ["OFFLINE_CONSULTS"],
        [requestId],
        updateRequestRemark,
        action,
        moment(scheduledAppointmentDate).format("YYYY-MM-DD HH:mm:ss.SSS"),
        doctorIdSelected,
        null,
        null,
        slotDistributionForDate,
        slotDistributionForInterval
      );
      if (response?.success) {
        setFetchData(!fetchData);
        toast.success("Request updated successfully");
      } else {
        toast.error(`Request update failed - ${response?.error}`);
      }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  const fetchProviderCalendar = async () => {
    let obj = {
      providerIds: [doctorIdSelected],
      noOfDays: 7,
      isHomeVisitCase: false,
      packageIds: [packageId],
      contractId: contractId,
      noOfSlots: 1,
      pmEntityID: 1018900,
      parentId: currentProvider,
    };
    let response = await getProvidersCalendar(obj);      
    setLoading(false);
    if (response.providerSlots?.[0]?.daySlots?.length) {
      setShowSlots(true);
      setDateSlots(response.providerSlots[0].daySlots);
      let date = response.providerSlots[0].daySlots.find((each) => !each.noSlotReason);
      if (date && date?.dateString) {
        setSelectedDate(date.dateString);
        date.workingDaySlots.slots.map((slot) => {
          let startTime = moment(slot.slotStartDateTime).format("hh:mm A");
          let endTime = moment(slot.slotEndDateTime).format("hh:mm A");
          slot.timeString = startTime + " - " + endTime;
        });
        setTimeSlots(date.workingDaySlots.slots);
      }
    }
  };

  const selectDate = (slot) => {
    setSelectedDate(slot.dateString);
    slot.workingDaySlots.slots.map((slot) => {
      let startTime = moment(slot.slotStartDateTime).format("hh:mm A");
      let endTime = moment(slot.slotEndDateTime).format("hh:mm A");
      slot.timeString = startTime + " - " + endTime;
    });
    setTimeSlots(slot.workingDaySlots.slots);
  };

  const fetchDoctors = async () => {
    let response = await availableDoctors(requestId);
    if (response?.success) {
      setDoctorList(response.data);
    }
  };
  useEffect(() => {
    fetchDoctors();
  }, []);

  useEffect(() => {
    fetchProviderCalendar();
  }, [doctor]);

  return (
    <Dialog open={rescheduleDialogVisible} onClose={() => setRescheduleDialogVisibility(false)} fullWidth={true} maxWidth={"sm"}>
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">Reschedule / Change Doctor</span>
            <div className="text-xs text-gray-500">
              Request ID: <span className="font-semibold">{requestId} </span>
            </div>
            <div className="text-xs text-gray-500">
              Appointment Date and Time: <span className="font-semibold">{moment(appointmentDate).format("MMMM Do YYYY hh:mm A")} </span>
            </div>
            <div className="text-xs text-gray-500">
              Speciality: <span className="font-semibold">{speciality} </span>
            </div>
            <div className="text-xs text-gray-500">
              Patient Name: <span className="font-semibold">{patientName} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={() => setRescheduleDialogVisibility(false)}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box className="mt-5">
          <div className="text-sm text-gray-500">
            Doctor Name: <span className="font-semibold">{doctorName} </span>
          </div>
          {showSlots ? (
            <div className="mt-5 mb-5">
              <div className="text-sm mb-2">Select Date and Time</div>
              <div className="m-1" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                <div className="flex">
                  {dateSlots && dateSlots.length ? (
                    dateSlots.map((slot) => (
                      <div
                        key={slot.dateString}
                        onClick={() => (!slot.noSlotReason ? selectDate(slot) : null)}
                        className="rounded-lg mr-2 pt-1 shadow text-center border"
                        style={{
                          minWidth: "80px",
                          color: slot.dateString === selectedDate ? "white" : slot.noSlotReason ? "#969696" : "black",
                          backgroundColor: slot.dateString === selectedDate ? "#1778f2" : "white",
                        }}
                      >
                        <div className="text-sm">{`${slot.dateString.split(" ")[1]} ${slot.dateString.split(" ")[2]}`}</div>
                        <div className="text-sm">{slot.workingDaySlots.dayOfWeek.substring(0, 3)}</div>
                        <div
                          className="text-xs mt-2 rounded-b-lg text-center"
                          style={{
                            backgroundColor: slot.noSlotReason ? "#fcfcfc" : "#faffe8",
                            color: slot.noSlotReason ? "#969696" : "#81a200",
                          }}
                        >
                          {slot.noSlotReason ? "Unavailable" : "Available"}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      <div className="text-sm">No Slots Available</div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex mt-3" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                {timeSlots && timeSlots.length ? (
                  timeSlots.map((slot) => (
                    <div
                      onClick={() => {
                        setOrderDateTime(slot.slotStartDateTime);
                        setSlotDistributionForDate(slot.slotDistributionForDate);
                        setSlotDistributionForInterval(slot.slotDistributionForInterval);
                      }}
                      className="border rounded mr-2 p-1"
                      style={{
                        width: "150px",
                        color: slot.slotStartDateTime == orderDateTime ? "white" : "black",
                        backgroundColor: slot.slotStartDateTime === orderDateTime ? "#1778f2" : "white",
                      }}
                    >
                      <div className="text-sm">{slot.timeString}</div>
                    </div>
                  ))
                ) : (
                  <div>
                    <div className="font-size-md">No Slots Available</div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            !loading && <>
              <div className="pb-5 pt-5">
                <TextField
                  className="w-full"
                  id="date"
                  label="Reschedule Date"
                  type="date"
                  value={rescheduleDate}
                  onChange={(evt) => setRescheduleDate(evt.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              <div className="pb-5">
                <TextField
                  className="w-full"
                  id="time"
                  label="Reschedule Time"
                  type="time"
                  value={rescheduleTime}
                  onChange={(evt) => setRescheduleTime(evt.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </>
          )}
          <div className="pb-5">
            <FormControl className="w-full">
              <InputLabel id="doctor">Select Doctor</InputLabel>
              <Select
                labelId="doctor"
                name="doctor"
                id="doctor"
                value={doctor}
                label="Select Doctor"
                onChange={(event) => {
                  setDoctor(event.target.value);
                  const reqDoctor = doctorList.filter((doc) => doc.doctorName == event.target.value);
                  let doctorId = reqDoctor && reqDoctor[0]?.doctorName != doctorName ? reqDoctor[0].doctorId : null;
                  setDoctorId(doctorId);
                }}
              >
                {doctorList.map((ele) => (
                  <MenuItem value={ele.doctorName}>{ele.doctorName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="pb-5">
            <FormControl className="w-full">
              <InputLabel id="reason">Select Reason</InputLabel>
              <Select
                labelId="reason"
                name="reason"
                id="reason"
                value={reason}
                label="Select Reason"
                onChange={(event) => {
                  setReason(event.target.value);
                }}
                required
              >
                {rescheduleReasons.map((ele) => (
                  <MenuItem value={ele}>{ele}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {reason === "Others" ? (
            <div className="pb-10">
              <FormControl className="w-full">
                <TextField
                  sx={{ fontSize: 14 }}
                  id="reasonOther"
                  label="Specify Reason*"
                  placeholder="Please specify the reason."
                  name="reasonOther"
                  onChange={(event) => setOtherReason(event.target.value)}
                  value={otherReason}
                />
              </FormControl>
            </div>
          ) : null}

          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={() => setRescheduleDialogVisibility(false)}
            >
              <span>Cancel</span>
            </div>
            <button
              className={
                reason === "" || rescheduleDate === "" || rescheduleTime === ""
                  ? "border-gray-500 bg-gray-500 text-gray-100 border cursor-default rounded-md w-40 p-1 text-sm font-semibold"
                  : "border-blue-600 bg-blue-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold"
              }
              type="submit"
              variant="contained"
              size="large"
              disabled={reason === "" || rescheduleDate === "" || rescheduleTime === ""}
              onClick={() => updateRequest()}
            >
              <span>Save and Confirm</span>
            </button>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
